<template>
  <v-row no-gutters >
    <v-col lg="8" md="12" sm="12" class="py-0">
      <v-textarea
        text
        auto-grow
        outlined
        v-model="texto"
        counter
        :maxlength="tammaximo"
        row-height="15"
        color="var(--vs-azul-secundaria)"
      ></v-textarea>
    </v-col>
    <v-col lg="4" md="12" sm="12" class="pl-4 py-0 pb-6 align-end d-flex">
      <vs-button
        color="primary"
        style="width: 140px !important"
        animation-type="scale"
        @click="postar()"
      >
        <i class="las la-sms pr-2" style="font-size: 20px !important"></i>
        <template>Perguntar</template>
      </vs-button>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data: () => ({
    texto: ""
  }),
  methods: {
    postar() {
      this.$emit("postar", { texto: this.texto });
      this.texto = "";
    }
  },
  props: ["tammaximo"]
};
</script>

<style>
</style>